import * as CookieConsent from "vanilla-cookieconsent";

function gtag(){
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(arguments);
}

export const config = {
  onModalShow: function(){
    const accessBtn = document.querySelector('[data-role="all"]')
    const rejectBtn = document.querySelector('[data-role="necessary"]')
    const preferencesBtn = document.querySelector('[data-role="show"]')

    const btnGroups = document.querySelectorAll('.cm__btn-group')

    btnGroups[0].append(preferencesBtn);

    rejectBtn.classList.add('cm__btn--secondary');
    accessBtn.classList.add('cm__btn--secondary');
    accessBtn.style.background = 'rgba(54, 201, 169, 1)';
    accessBtn.style.color = 'white';

    btnGroups[1].append(accessBtn);
  },
  onConsent: function(){
    let consentMode = {
      'functionality_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
      'security_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
      'personalization_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
      'ad_storage': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
      'ad_user_data': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
      'ad_personalization': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
      'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
    }

    gtag('consent', 'update', consentMode);
    localStorage.setItem('consentMode', JSON.stringify(consentMode));
  },
  guiOptions: {
    consentModal: {
      layout: "bar",
      position: "bottom",
      equalWeightButtons: true,
      flipButtons: false
    },
    preferencesModal: {
      layout: "box",
      position: "right",
      equalWeightButtons: true,
      flipButtons: false
    }
  },
  categories: {
    necessary: {
      readOnly: true
    },
    analytics: {
      enabled: true
    },
    marketing: {
      enabled: true
    }
  },
  language: {
    default: "en",
    autoDetect: "browser",
    translations: {
      en: {
        consentModal: {
          title: "Cookie Usage",
          description: "This website uses cookies and other tracking technologies to improve your browsing experience for the following purposes: to enable basic functionality of the website, to provide a better experience on the website, to measure your interest in our products and services and to personalize marketing interactions, to deliver ads that are more relevant to you.",
          closeIconLabel: "",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          showPreferencesBtn: "Manage preferences",
          footer: "<a href=\"https://mybid.io/privacy-policy\" target=\"_blank\">Privacy Policy</a><a href=\"https://mybid.io/terms-and-conditions\" target=\"_blank\">Terms and conditions</a>"
        },
        preferencesModal: {
          title: "Consent Preferences Center",
          closeIconLabel: "Close modal",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          savePreferencesBtn: "Save preferences",
          serviceCounterLabel: "Service|Services",
          sections: [
            {
              title: "Cookie Usage",
              description: "We use cookies to provide you with the best possible experience. They also allow us to analyze user behavior in order to constantly improve the website for you.",
            },
            {
              title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
              description: "Storage variables manage functionality, security, and personalization settings for apps and websites.",
              linkedCategory: "necessary"
            },
            {
              title: "Analytics Cookies",
              description: "Enables storage (such as cookies) related to analytics e.g. visit duration.",
              linkedCategory: "analytics",
              enabled: true
            },
            {
              title: "Advertisement Cookies",
              description: "Advertising variables manage storage, user data, and consent for personalized and general ads.",
              linkedCategory: "marketing"
            },
            {
              title: "More information",
              description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href=\"mailto:hello@mybid.io\">contact me</a>."
            }
          ]
        }
      }
    }
  },
  disablePageInteraction: true
};
